module.exports = __webpack_public_path__ + "static/img/4KYC.b259e8f2.gif";